import React from 'react'
import { FastField } from 'formik'

import NoValue from '@modules/form/components/NoValue'
import FieldGroup from '@modules/form/components/FieldGroup'
import './InterviewResults.scss'

const levelLabels = [
	'Poor',
	'Fair',
	'Good',
	'Excellent',
];

const RadioIndicator = ({ field, value, ...props }) => {
	const selected = field.value != null && field.value === value;
	return <span className={`RadioIndicator ${selected ? 'selected' : ''}`} {...props}></span>
}

class InterviewResultsLineDisplay extends React.Component {

	render() {
		const { field, label } = this.props;
		return (
			<tr key={field.name}>
				<td>{label}:</td>
				<td>
					{ field.value == null
						? <NoValue />
						: levelLabels[field.value]
					}
				</td>
			</tr>
		)

	}

}


class InterviewResultsLineInput extends React.Component {

	renderIndicators() {
		const { field, form } = this.props;
		return [3,2,1,0].map(n => 
			<td key={n}>
				<RadioIndicator onClick={() => form.setFieldValue(field.name, n, false)} value={n} field={field} />
			</td>
		);
	}

	render() {
		const { label } = this.props;
		return (
			<tr>
				<td>{label}:</td>
				{ this.renderIndicators() }
			</tr>
		)
	}

} 

export default
class InterviewResults extends React.Component {

	render() {
		const { isEditing, field } = this.props;
		const LineComponent = isEditing ? InterviewResultsLineInput : InterviewResultsLineDisplay;
		return (
			<div className={`InterviewResults ${isEditing ? 'isEditing' : ''}`}>
				<table>
					{ isEditing && this.renderTableHead() }
					<tbody>
						<FastField 
							name={`${field.name}.attitude`} 
							label="Attitude" 
							component={LineComponent}
						/>
						<FastField 
							name={`${field.name}.languageSkills`} 
							label="Language Skills" 
							component={LineComponent}
						/>
						<FastField 
							name={`${field.name}.appearance`} 
							label="Appearance" 
							component={LineComponent}
						/>
						<FastField 
							name={`${field.name}.workExperience`} 
							label="Work Experience" 
							component={LineComponent}
						/>
						<FastField 
							name={`${field.name}.requiredSkills`} 
							label="Required Skills" 
							component={LineComponent}
						/>
						<FastField 
							name={`${field.name}.charisma`} 
							label="Charisma" 
							component={LineComponent}
						/>
					</tbody>
				</table>

				{
					// If editing or not editing and has value
					(isEditing || (!isEditing && field.value && field.value.notes && field.value.notes.length)) &&
					
					<FieldGroup 
						name={`${field.name}.notes`} 
						label={ !isEditing ? 'Notes' : ''}
						placeholder="Notes..." 
						component="textarea"
						isEditing={isEditing}
					/>

				}



			</div>
		)
	}

	renderTableHead() {
		return (
			<thead>
				<tr>
					<th></th>
					<th>Excellent</th>
					<th>Good</th>
					<th>Fair</th>
					<th>Poor</th>
				</tr>
			</thead>
		);
	}

	// renderDisplay() {
	// 	return 'Display';

	// }
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/InterviewResults/InterviewResults.jsx